import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { paths } from '@src/routes/paths';

import { FeatureFlag } from 'src/auth/feature-flags';
import FeatureFlagGuard from 'src/auth/guard/feature-flag-guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('../pages/CompanyPartnerIndexPage'));
const CreatePage = lazy(() => import('../pages/CompanyPartnerCreatePage'));
const EditPage = lazy(() => import('../pages/CompanyPartnerEditPage'));

// ----------------------------------------------------------------------
// Auth/Onboarding/DashboardLayout/Suspense are provided once by the shared
// dashboard shell (routes/pages/dashboard) — this only adds this domain's
// own feature flag check on top of it.
export const companyPartnerRoutes = [
  {
    path: paths.dashboard.company_partner.index.replace('/dashboard/', ''),
    element: (
      <FeatureFlagGuard flag={FeatureFlag.CompanyPartners}>
        <Outlet />
      </FeatureFlagGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'create', element: <CreatePage /> },
      { path: 'edit/:id', element: <EditPage /> },
    ],
  },
];
